import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Col,
  Row,
  Badge,
  CardHeader,
  Spinner,
} from 'reactstrap';
import { api } from '../../config';
import CountUp from 'react-countup';
import FeatherIcon from 'feather-icons-react';

const WidgetStatusMitra = ({ token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const res = await fetch(`${api.API_URL}/dashboard/get-mitra`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error('Failed to fetch data');
        }

        const result = await res.json();
        setData(result);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    if (token) {
      fetchData();
    }
  }, [token]);

  const getValueByKey = key => {
    if (!Array.isArray(data)) return 0;
    const item = data.find(item => item.key === key);
    return item ? item.value : 0;
  };

  const summaryItems = [
    {
      key: 'TotalProcurements',
      label: 'Total Procurements Invitation',
      icon: 'layers',
      color: 'primary',
    },
    {
      key: 'TotalDraft',
      label: 'Draft Procurements',
      icon: 'file-text',
      color: 'warning',
    },
    {
      key: 'TotalSubmitted',
      label: 'Submitted Procurements',
      icon: 'send',
      color: 'success',
    },
    {
      key: 'TotalOpening',
      label: 'Opening Process',
      icon: 'play-circle',
      color: 'info',
    },
    {
      key: 'TotalClosing',
      label: 'Closing Process',
      icon: 'check-circle',
      color: 'secondary',
    },
    {
      key: 'TotalSubmissionDeadlineMissed',
      label: 'Missed Deadline',
      icon: 'alert-circle',
      color: 'danger',
    },
  ];

  if (loading) {
    return (
      <Card className='h-100'>
        <CardBody
          className='d-flex justify-content-center align-items-center'
          style={{ minHeight: '200px' }}
        >
          <Spinner color='primary' />
        </CardBody>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className='border-0 shadow-sm rounded-3 h-100'>
        <CardBody
          className='d-flex justify-content-center align-items-center'
          style={{ minHeight: '200px' }}
        >
          <p className='text-danger mb-0'>Error: {error}</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className='border-0 shadow-sm rounded-3'>
      <CardHeader className='bg-transparent border-0 px-4 pt-4 d-flex align-items-center gap-2'>
        <FeatherIcon icon='bar-chart-2' size={16} className='text-primary' />
        <div>
          <h5 className='mb-1 fw-semibold'>Tender Overview</h5>
          <p className='text-muted mb-0 fs-13'>
            Summary of tender activities and statuses
          </p>
        </div>
        <Badge color='primary' pill className='ms-auto fw-normal'>
          {summaryItems.length} Metrics
        </Badge>
      </CardHeader>

      <CardBody className='p-4'>
        <Row className='g-3'>
          {summaryItems.map(item => {
            const value = getValueByKey(item.key);

            return (
              <Col key={item.key} xl={3} md={6}>
                <div className='d-flex align-items-center p-3 rounded-3 border bg-white h-100 dashboard-metric-card'>
                  <div className='dashboard-stat-icon me-3'>
                    <span
                      className={`d-inline-flex align-items-center justify-content-center bg-${item.color}-subtle rounded-3 text-${item.color} fs-5`}
                    >
                      <FeatherIcon icon={item.icon} size={18} />
                    </span>
                  </div>
                  <div className='flex-grow-1 min-width-0'>
                    <p className='text-muted mb-1 fs-12 text-truncate text-uppercase fw-medium'>
                      {item.label}
                    </p>
                    <h4 className='fw-bold mb-0 text-dark'>
                      <CountUp start={0} end={value} duration={2} />
                    </h4>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </CardBody>
    </Card>
  );
};

export default WidgetStatusMitra;
